var GeneratePlrButton, GeneratePlrToolbarView, ReactComponent, View,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

GeneratePlrButton = require('components/etd/generate_plr_button');

ReactComponent = require('base/lib/traits/react_component');

View = require('base/views/view');

module.exports = GeneratePlrToolbarView = (function(_super) {
  __extends(GeneratePlrToolbarView, _super);

  function GeneratePlrToolbarView() {
    return GeneratePlrToolbarView.__super__.constructor.apply(this, arguments);
  }

  GeneratePlrToolbarView.prototype.autoRender = true;

  GeneratePlrToolbarView.prototype.initialize = function() {
    GeneratePlrToolbarView.__super__.initialize.apply(this, arguments);
    return this.enable(ReactComponent);
  };

  GeneratePlrToolbarView.prototype.afterRender = function() {
    var _ref;
    GeneratePlrToolbarView.__super__.afterRender.apply(this, arguments);
    return this.renderSimpleComponent(GeneratePlrButton, {
      hasRecommendation: Boolean((_ref = this.model.get('recommendationIds')) != null ? _ref[0] : void 0),
      questionId: this.model.get('_id')
    });
  };

  GeneratePlrToolbarView.prototype.dispose = function() {
    if (this.disposed) {
      return;
    }
    this.unmountComponent();
    return GeneratePlrToolbarView.__super__.dispose.apply(this, arguments);
  };

  return GeneratePlrToolbarView;

})(View);
